var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manual-download-links btn btn-link",on:{"click":_vm.downloadManual}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "+_vm._s(_vm.userSettings.common.manual_download_file_name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }